import type * as z from "zod";
import { searchInputOf, searchResultOf } from "../search";

// What booking finds (ADR-117). Each type needs the permission of its list, and the same one opens it in the app.

export const bookingSearchTypes = ["sales_campaign", "appointment"] as const;
export type BookingSearchType = (typeof bookingSearchTypes)[number];

export const bookingSearchPermissions = {
  sales_campaign: "booking.read",
  appointment: "booking.read",
} as const satisfies Record<BookingSearchType, string>;

export const searchBookingInput = searchInputOf(bookingSearchTypes);
export type SearchBookingInput = z.input<typeof searchBookingInput>;

export const bookingSearchDto = searchResultOf(bookingSearchTypes).meta({ id: "BookingSearch" });
export type BookingSearch = z.output<typeof bookingSearchDto>;
